import {Observable} from 'rxjs'
import {ServiceOverviewPage} from '../types/service-overview-page.types'
import {map} from 'rxjs/operators'
import {pickProperty} from '../../graphql/graphql-utils'
import {CMS_GRAPHQL_CLIENT_NAME} from '../content-graphql-split'
import {GetServiceOverviewPageGql, ServiceOverviewPageFieldsFragment} from '../../../../__generated__/datocms.types'
import {TranslocoService} from '@ngneat/transloco'
import {getSiteLocale} from '../site-locale'
import {Injectable} from '@angular/core'
import {parseServiceOverviewPage} from '../serde/service-overview-page.serde'
import {LinkService} from '../../i18n/link.service'
import {sanitizeSlug} from '../sanitize-slug'

@Injectable()
export class ServiceOverviewPageContentService {
  constructor(
    private readonly getServiceOverviewPageBySlugGql: GetServiceOverviewPageGql,
    private readonly locale: TranslocoService,
    private readonly linkService: LinkService,
  ) {}

  getServiceOverviewPage(pageSlug: string): Observable<ServiceOverviewPage> {
    return this.getServiceOverviewPageBySlugGql
      .fetch(
        {locale: getSiteLocale(this.locale), pageSlug: sanitizeSlug(pageSlug)},
        {context: {clientName: CMS_GRAPHQL_CLIENT_NAME}},
      )
      .pipe(
        map(res => pickProperty(res.data, 'serviceOverviewPageModel')),
        map(page => parseServiceOverviewPage(this.linkService, page as ServiceOverviewPageFieldsFragment)),
      )
  }
}
